import { createApp } from "vue";
import App from "@/app/App.vue";
import { router } from "@/app/router";
import { store } from "@/app/store";
import VueCookies from "vue-cookies";
import { i18n } from "@/app/plugins/i18n/VueI18n";
import VueScreen from "vue-screen";
import "@/app/plugins/Vee-validate/validator";
import * as Sentry from "@sentry/vue";
import phoneMask from "@/shared/lib/directives/phoneMask";
import OnlyNumbers from "@/shared/lib/directives/onlyNumbers";
import clickOutside from "@/shared/lib/directives/clickOutside";
import CustomApiService from "@/shared/services/custom.api.service";
import AuthlessApiService from "@/shared/services/authless.api.service";
import CONFIG from "@/app/config";
import ToastWrapper from "@/app/plugins/toast";
import AuthService from "@emcd-shared/auth-service";

// EMCD Styles
import "@/assets/tailwind.css";
import "@/assets/scss/global.scss";
import authlessApiPlugin from "./app/plugins/authlessApiPlugin";
import customApiPlugin from "./app/plugins/customApiPlugin";

// Public page: a session that can not be restored leaves the visitor as a
// guest instead of sending them to the login page (CHWI-5342).
AuthService.setLoginRedirect(false);

// Creating Vue App
const app = createApp(App);

// Plugins
app.use(router);
app.use(ToastWrapper);
app.use(store);
app.use(VueCookies, { expires: "30d", path: "/" });
app.use(i18n);
app.use(customApiPlugin, {
  CustomApiService,
});
app.use(authlessApiPlugin, {
  AuthlessApiService,
});
// Vue Screen
app.use(VueScreen, {
  grid: {
    xs: 576,
    sm: 768,
    md: 1024,
    lg: 1200,
  },
});

// Directives
app.directive("phone-mask", phoneMask);
app.directive("only-numbers", OnlyNumbers());
app.directive("clickOutside", clickOutside);

app.config.globalProperties.$formatAmount = function (value) {
  return Number(value)?.toLocaleString(undefined);
};

app.config.globalProperties.$formatPercent = function (value) {
  return parseFloat(Number(value)?.toFixed(2));
};

Sentry.init({
  app,
  dsn: CONFIG.SENTRY_DSN, // TODO(i.zhuravlev): GITLAB_ENV
  release: CONFIG.VERSION || "0.0.1",
  environment: CONFIG.ENVIRONMENT || "development",
  debug: CONFIG.SENTRY_DEBUG === "true",
  integrations: [Sentry.browserTracingIntegration({ router })],
  tracePropagationTargets: ["http://localhost:8080/explorer/"],
  tracesSampleRate: 1.0,
  trackComponents: true,
  hooks: ["mount", "update", "destroy"],
  beforeSend(event) {
    return event;
  },
  attachStacktrace: true,
  enableTracing: true,
});

// Mounting the configured Vue App
app.mount("#app");
